const MAX_CHECKS = 10;
const CHECK_INTERVAL = 500;

const isFacebookLoaded = function() {
    return typeof window.fbq !== 'undefined';
};

const whenParsed = function(callback: () => void) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, {once: true});
        return;
    }

    callback();
};

const onFacebookPixelLoaded = function(callback: () => void) {
    if (isFacebookLoaded()) {
        callback();
        return;
    }

    whenParsed(function() {
        let checks = 0;

        const poll = function() {
            if (isFacebookLoaded()) {
                callback();
                return;
            }

            if (++checks >= MAX_CHECKS) {
                return;
            }

            setTimeout(poll, CHECK_INTERVAL);
        };

        poll();
    });
};

export default onFacebookPixelLoaded;
